let faqData = [];

async function getFaqData() {
    let url = document.getElementById('faq-questions').getAttribute('url');
    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
        }

        const data = await response.json();
        faqData = data.questions || [];
    } catch (error) {
        console.error("Erro ao carregar perguntas:", error);
        faqData = []; // Ensure faqData is an empty array on error
    }

    return faqData;
}

function renderFaq(category, faqData) {
    const container = document.getElementById('faq-questions');
    container.innerHTML = '';
    faqData[category].forEach((item, idx) => {
        const card = document.createElement('div');
        card.className = 'break-inside-avoid bg-white rounded-[5px] border-solid border-[#04243B] border-[.2px] px-[28px] py-6 cursor-pointer transition-all duration-200 hover:bg-[#E6F4FA] min-h-[70px] flex items-start justify-between pt-[15px] shadow-[4px_4px_10px_0px_#0000000D] mb-[20px]';
        card.innerHTML = `
            <div class="flex-1">
                <h3 class="font-bold lg:text-[20px] text-[16px] lg:leading-[45px] leading-[32px] text-[#04243B]">${idx + 1}. ${item.q}</h3>
                <p class="text-[#fff] text-[15px] leading-[25px] hidden lg:pb-[30px] lg:pt-[0px] pt-[12px]">${item.a}</p>
            </div>
            <span class="faq-toggle-icon text-2xl ml-4 lg:text-[40px] text-[35px] select-none text-[#09A7DA] lg:leading-[40px] leading-[35px]">+</span>
        `;
        const answer = card.querySelector('p');
        const icon = card.querySelector('.faq-toggle-icon');
        const question = card.querySelector('h3');
        card.addEventListener('click', () => {
            // Close all other cards
            container.querySelectorAll('div.break-inside-avoid').forEach(otherCard => {
                if (otherCard !== card) {
                    const otherAnswer = otherCard.querySelector('p');
                    const otherIcon = otherCard.querySelector('.faq-toggle-icon');
                    const otherQuestion = otherCard.querySelector('h3');
                    otherAnswer.classList.add('hidden');
                    otherCard.style.background = '';
                    otherCard.style.borderColor = '#04243B';
                    otherCard.classList.add('bg-white', 'hover:bg-[#E6F4FA]');
                    otherQuestion.style.color = '#04243B';
                    otherIcon.textContent = '+';
                    otherIcon.style.color = '#09A7DA';
                }
            });
            // Toggle this card
            const isOpen = !answer.classList.contains('hidden');
            if (!isOpen) {
                answer.classList.remove('hidden');
                card.style.background = '#09A7DA';
                card.style.borderColor = '#09A7DA';
                card.classList.remove('bg-white', 'hover:bg-[#E6F4FA]');
                question.style.color = '#fff';
                answer.style.color = '#fff';
                icon.textContent = '-';
                icon.style.color = '#09A7DA';
            } else {
                answer.classList.add('hidden');
                card.style.background = '';
                card.style.borderColor = '#04243B';
                card.classList.add('bg-white', 'hover:bg-[#E6F4FA]');
                question.style.color = '#04243B';
                answer.style.color = '#fff';
                icon.textContent = '+';
                icon.style.color = '#09A7DA';
            }
        });
        container.appendChild(card);
    });
}

// Load FAQ data and dispatch event to render
document.addEventListener('DOMContentLoaded', function() {
    getFaqData().then((data) => {
        faqData = data;

        // Render inicial
        renderFaq("1", faqData);

        // Esconde a categoria "Resultado"
        const resultCategory = document.querySelector('.faq-category-btn[data-category="0"]');
        if (resultCategory) resultCategory.style.display = 'none';

        // Marcar primeira categoria como ativa
        const firstBtn = document.querySelectorAll('.faq-category-btn')[1]; // índice 1, porque 0 é "Resultado"
        if (firstBtn) {
            firstBtn.style.borderBottom = '1px solid #09A7DA';
            firstBtn.querySelector('span').style.color = '#09A7DA';
            firstBtn.querySelector('img').style.filter = 'brightness(0) saturate(100%) invert(66%) sepia(61%) saturate(6265%) hue-rotate(163deg) brightness(100%) contrast(93%)';
        }

        // Clique nas categorias
        document.querySelectorAll('.faq-category-btn').forEach(btn => {
            btn.addEventListener('click', function() {
                // Remove highlight de todos
                document.querySelectorAll('.faq-category-btn').forEach(b => {
                    b.style.borderBottom = 'none';
                    b.querySelector('span').style.color = '#04243B';
                    b.querySelector('img').style.filter = 'none';
                });

                // Ativa o atual
                this.style.borderBottom = '1px solid #09A7DA';
                this.querySelector('span').style.color = '#09A7DA';
                this.querySelector('img').style.filter = 'brightness(0) saturate(100%) invert(66%) sepia(61%) saturate(6265%) hue-rotate(163deg) brightness(100%) contrast(93%)';

                // Renderiza
                renderFaq(this.dataset.category, faqData);
            });
        });

        // Formulário de busca
        const form = document.getElementById('faq-form');
        if (form) {
            const input = form.querySelector('input[type="text"]');

            form.addEventListener('submit', function(e) {
                e.preventDefault();
                handleSearch(input.value.trim());
            });

            // Atualiza dinamicamente enquanto digita
            input.addEventListener('input', function() {
                if (this.value.trim() === '') {
                    // Volta ao estado normal
                    if (resultCategory) resultCategory.style.display = 'none';
                    document.querySelectorAll('.faq-category-btn').forEach(b => {
                        if (b.dataset.category !== '0') b.style.display = '';
                    });
                    const firstBtn = document.querySelectorAll('.faq-category-btn')[1];
                    if (firstBtn) firstBtn.click();
                } else {
                    handleSearch(this.value.trim());
                }
            });
        }

        function handleSearch(query) {
            const results = [];

            if (query) {
                Object.keys(faqData).forEach(category => {
                    faqData[category].forEach(item => {
                        if (
                            item.q.toLowerCase().includes(query.toLowerCase()) ||
                            item.a.toLowerCase().includes(query.toLowerCase())
                        ) {
                            results.push(item);
                        }
                    });
                });

                if (results.length > 0) {
                    // Mostra categoria de resultados
                    if (resultCategory) resultCategory.style.display = '';

                    // Esconde as outras categorias
                    document.querySelectorAll('.faq-category-btn').forEach(b => {
                        if (b.dataset.category !== '0') b.style.display = 'none';
                    });

                    // Renderiza apenas os resultados
                    renderFaq("0", { "0": results });

                    // Destaca categoria resultado
                    document.querySelectorAll('.faq-category-btn').forEach(b => {
                        b.style.borderBottom = 'none';
                        b.querySelector('span').style.color = '#04243B';
                        b.querySelector('img').style.filter = 'none';
                    });
                    resultCategory.style.borderBottom = '1px solid #09A7DA';
                    resultCategory.querySelector('span').style.color = '#09A7DA';
                    resultCategory.querySelector('img').style.filter = 'brightness(0) saturate(100%) invert(66%) sepia(61%) saturate(6265%) hue-rotate(163deg) brightness(100%) contrast(93%)';
                } else {
                    // Nenhum resultado
                    // alert('Nenhum resultado encontrado!');
                }
            }
        }
    });
});
